<template>
  <span class="d-flex ai-baseline">
    <slot name="pre"/>

    <span class="d-flex flex-1-1 m-y-1">
      <span :style="{ width: `${width}%` }" class="BAR bg-depot"/>
      <span :style="{ width: `${rest}%` }" class="BAR bg-gray30"/>
    </span>

    <slot name="post"/>
  </span>
</template>

<script>

export default {
  name: 'percentage-bar',
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    width () {
      return this.value * 100;
    },
    rest () {
      return 100 - this.width;
    },
  },
};
</script>

<style lang="scss" scoped>
  .BAR {
    height: 8px;
  }
</style>
